import * as React from 'react'
import 'src/core/assets/loader.css'
import 'src/core/utils/linq'

import {CacheProps, withCache} from '../core/services/cache.service'
import {IdentityProps, withIdentity} from "src/core/services/authentication";
import {RouteComponentProps, withRouter} from 'react-router-dom'
import {withUserProfile} from "../components/user-profile";

interface NotificationContentProps extends CacheProps, IdentityProps, RouteComponentProps {
    
}

interface NotificationContentStatus {
}



class NotificationService {
   
    private props: NotificationContentProps
    constructor(props: NotificationContentProps) {
        
        this.props = props;
    }

    public ActiveCompany: string | undefined;
    public Employee: string | undefined;

    public ChangeActiveCompany(companyId: string) {
        this.ActiveCompany = companyId;
       
    }
    public ChangeEmployee(employeeId: string) {
        this.Employee = employeeId;
    }

}

let notificationService: NotificationService

const { Provider, Consumer } = React.createContext<NotificationService>(undefined as any)

class NotificationContent extends React.Component<NotificationContentProps, NotificationContentStatus> {
    private notificationService: NotificationService

    constructor(props: NotificationContentProps) {
        super(props)
        this.notificationService = notificationService = new NotificationService(this.props)
         
        this.state = {
            ForceShowModal: 0
        }

    }
  

    private beginNotification(): NotificationService {
        return this.notificationService
    }

    public render() {

        return <Provider value={this.beginNotification() as any}>
            {this.props.children}
        </Provider>
            ||
            <div></div>
    }
}

export interface NotificationProps {
    notifications: NotificationService
}

export function withNotification<T extends React.ComponentType<any>>(Component: T) {
    
    return function ComponentBoundWithAppContext(props: any) {
       
        return (
            <Consumer>
                {appContext => <Component {...props} notifications={appContext} />}
            </Consumer>
        )
    }
}


export { notificationService }
export default withUserProfile(withCache(withIdentity(withRouter(NotificationContent))))